import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export const REMOVE_LABEL_FROM_ARTICLE =
	'state.actions.remove-label-from-article.REMOVE_LABEL_FROM_ARTICLE' as const;

export type RemoveLabelFromArticlePayload = {
	label: string;
	articleId: string;
	spaceKey: string;
	analyticsEvent: UIAnalyticsEvent;
};

export type RemoveLabelFromArticleAction = {
	type: typeof REMOVE_LABEL_FROM_ARTICLE;
	payload: RemoveLabelFromArticlePayload;
};

export const removeLabelFromArticle = (
	payload: RemoveLabelFromArticlePayload,
): RemoveLabelFromArticleAction => ({
	payload,
	type: REMOVE_LABEL_FROM_ARTICLE,
});
